import { useState, useEffect } from "react";
import { useSEO } from "@/hooks/useSEO";
import { Navbar } from "@/components/Navbar";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = "/api";

export default function PrivacyPage() {
  useSEO({ title: "Privacy Policy - Fotovoltaico Chiavi in Mano" });
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/privacy-page`)
      .then((r) => setSections(r.data.sections || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const renderContent = (content) => {
    if (!content) return null;
    const lines = content.split("\n");
    const elements = [];
    let listItems = [];

    const flushList = () => {
      if (listItems.length > 0) {
        elements.push(
          <ul key={`list-${elements.length}`} className="text-sm text-slate-600 space-y-1.5 list-disc pl-5 mb-3">
            {listItems.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
        );
        listItems = [];
      }
    };

    lines.forEach((line, i) => {
      const trimmed = line.trim();
      if (trimmed.startsWith("- ") || trimmed.startsWith("* ")) {
        listItems.push(trimmed.slice(2));
      } else {
        flushList();
        if (trimmed) {
          elements.push(
            <p key={`p-${i}`} className="text-sm text-slate-600 leading-relaxed mb-3">{trimmed}</p>
          );
        }
      }
    });
    flushList();
    return elements;
  };

  return (
    <div className="min-h-screen bg-white" data-testid="privacy-page">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-8" style={{ fontFamily: "Outfit, sans-serif" }}>
          Privacy Policy e Cookie Policy
        </h1>

        {loading ? (
          <div className="text-center py-16"><Loader2 className="w-6 h-6 animate-spin text-slate-400 mx-auto" /></div>
        ) : sections.length > 0 ? (
          <div className="space-y-8">
            {sections.map((section, i) => (
              <section key={i} data-testid={`privacy-section-${i}`}>
                {section.title && (
                  <h2 className="text-xl font-bold text-slate-800 mb-3" style={{ fontFamily: "Outfit, sans-serif" }}>
                    {section.title}
                  </h2>
                )}
                {renderContent(section.content)}
              </section>
            ))}
          </div>
        ) : (
          <p className="text-sm text-slate-500">Privacy policy in fase di aggiornamento.</p>
        )}
      </div>
    </div>
  );
}
